import PaymentController from '../../api/controllers/paymentController';
import {
  paymentInitActionType,
  errorBlockTransactionDisplay,
} from '../../actionTypes';
import onTransactionErrorBlock from '../onTransactionErrorBlock';
import getTransactionExperimentData from './getTransactionExperimentData';
import { posCustomerPaymentSuccessRoute } from '../../alias/paymentRoutes';
import { route } from 'preact-router';

export default (actionPayload) => (dispatch, getState) => {
  const { txnUuid } = actionPayload || {};
  const { config } = getState();
  const { sourceRef } = config || {};
  dispatch({
    type: paymentInitActionType.TRANSACTION_INFO_REQUEST,
    payload: { txnUuid },
  });
  return PaymentController.getPosTxnDetails({ txnUuid, sourceRef })
    .then((res) => {
      const {
        gatewayMerchantId: merchantId,
        mobile: mobileNo,
        purchaseValue,
        lenderDetailsList,
        selectedLenderDetails,
        userStatus,
        returnUrl,
        remainingTimeSeconds,
        pgData,
        isOfferEligible,
        timeoutErrorModel,
        channel,
        isNoCostEmiAvailable,
        merchantName,
        txnTerminated,
      } = res.data || {};
      dispatch(getTransactionExperimentData());
      dispatch({
        type: paymentInitActionType.TRANSACTION_TIMEOUT_STORE,
        payload: { pgData, returnUrl, channel },
      });
      if (timeoutErrorModel) {
        const {
          cta = '',
          errorType = '',
          helpText = '',
          message = '',
          title = '',
        } = timeoutErrorModel || {};
        dispatch({
          type: errorBlockTransactionDisplay.DISPLAY_HELP_TEXT,
          payload: { helpText, title, message, cta, errorType },
        });
      }

      if (mobileNo) {
        if (selectedLenderDetails) {
          //dispatch mobile-number and transaction details
          //pre-selected lender details
          const { emiDetails, lenderType } = selectedLenderDetails;
          emiDetails['lenderType'] = lenderType;
          dispatch({
            type: paymentInitActionType.TRANSACTION_INFO_PRE_SELECTED_SUCCESS,
            payload: {
              merchantId,
              mobile: mobileNo,
              purchaseValue,
              selectedLender: selectedLenderDetails,
              selectedEmiDetails: emiDetails,
              merchantName,
            },
          });
        }
      }

      const detailsTimestampSeconds = '';
      dispatch({
        type: paymentInitActionType.TRANSACTION_INFO_SUCCESS,
        payload: {
          eligible: 'true',
          merchantId,
          mobile: mobileNo,
          purchaseValue,
          userStatus,
          lenderDetailsList: lenderDetailsList || [],
          selectedLender: selectedLenderDetails,
          remainingTimeSeconds,
          isFlipkartOfferEligible: isOfferEligible,
          channel,
          isNoCostEmiAvailable,
          detailsTimestampSeconds,
        },
      });

      if (txnTerminated) {
        const displayPaymentContainer = true;
        dispatch({
          type: paymentInitActionType.UPDATE_TXN_TERMINATION_DATA,
          payload: { displayPaymentContainer, txnTerminated },
        });

        route(
          `${posCustomerPaymentSuccessRoute.path}${window.location.search}`,
          true,
        );
      }
    })
    .catch(({ data }) => {
      const { errorData, message, cta, errorType, helpText, title } =
        data || {};
      const { pgData, returnUrl, channel } = errorData || {};

      dispatch({
        type: paymentInitActionType.TRANSACTION_INFO_ERROR,
        payload: { pgData, returnUrl, channel },
      });

      dispatch(
        onTransactionErrorBlock({ cta, errorType, helpText, title, message }),
      );
    });
};



// WEBPACK FOOTER //
// ./actions/onPaymentInit/getPosTransactionInfo.js